import { createContext } from 'react';

import { GridSortModel } from '@mui/x-data-grid';
import { UseFormReturn } from 'react-hook-form';
import { AxiosResponse } from 'axios';

import { ChatUser, Image, PublicLink, Team } from '@vyce/core/src/types';
import {
  AddMemberRequestDTO,
  ChangeTeamManagersData,
  CreateTeamData,
  DeleteMemberRequestDTO,
  GetCompanyTeamsMembersDataRequest,
  GetStaffResponse,
  GetSyncSettingsData,
  ListStaffRequest,
  ModuleCandidatatesSchema,
} from '@vyce/core/src/api/types';

interface Context {
  open: boolean;
  logo?: Image;
  total: number;
  loading: boolean;
  sortModel: GridSortModel;
  substring: string;
  methods: UseFormReturn<CreateTeamData, any>;
  teamData?: Team;
  setTeamData?: (data: Team | undefined) => void;
  pathname: string;
  openDeleteTeamDialog: boolean;
  selectionModel: string[];
  selectedCompanyId: string;
  teamId: string;
  setOpen: Function;
  setLogo: Function;
  setOpenDeleteTeamDialog: Function;
  setSelectionModel: Function;
  isPublicLinkDialogOpen?: boolean;
  publicLink?: PublicLink;
  setOffset: (offset: number) => void;
  handleSearchChange: (event: any) => void;
  handleSortModelChange: (newModel: GridSortModel) => void;
  handlePageChange: (newPage: number) => void;
  handleSubmit: (data: CreateTeamData) => Promise<void>;
  deleteTeam: () => Promise<void>;
  addTeamMembersRequest: (
    companyId: string,
    teamId: string,
    userIds: AddMemberRequestDTO
  ) => Promise<AxiosResponse<any, any>>;
  getPublicLink?: () => Promise<void>;
  closePublicLinkDialog?: () => void;
  getTeamsCandidatesRequest: (
    props: GetSyncSettingsData & {
      payload: ModuleCandidatatesSchema;
    }
  ) => Promise<AxiosResponse<any, any>>;
  getTeamMembersRequest: (
    companyId: string,
    teamId: string,
    requestData: GetCompanyTeamsMembersDataRequest,
    signal?: AbortSignal
  ) => Promise<AxiosResponse<any, any>>;
  deleteTeamMembersRequest: (
    companyId: string,
    teamId: string,
    data: DeleteMemberRequestDTO
  ) => Promise<AxiosResponse<any, any>>;

  changeTeamManagersRequest: (
    companyId: string,
    teamId: string,
    managers: ChangeTeamManagersData
  ) => Promise<AxiosResponse<any, any>>;
  removeUsersFromChat?: ({
    companyId,
    entityId,
    userIds,
  }: {
    companyId: string;
    entityId: string;
    userIds: string[];
  }) => Promise<void>;
  getStaffRequest: (companyId: string, payload: ListStaffRequest) => Promise<AxiosResponse<GetStaffResponse>>;
  chatUser?: ChatUser;
}

export const TeamModuleContext = createContext({} as Context);

export const TeamModuleProvider = TeamModuleContext.Provider;
